import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Tag, Space, Typography, Divider, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { blogPosts } from '../../api/mockData';
import './index.css';

const { Title, Paragraph, Text } = Typography;

const PostDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);

  useEffect(() => {
    // 根据ID查找文章
    const foundPost = blogPosts.find(post => post.id === parseInt(id));
    setPost(foundPost);
  }, [id]);

  const handleBack = () => {
    navigate('/');
  };

  if (!post) {
    return (
      <div className="post-detail-container">
        <Card>
          <Title level={2}>文章未找到</Title>
          <Button 
            type="primary" 
            icon={<LeftOutlined />} 
            onClick={handleBack}
          >
            返回首页
          </Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="post-detail-container">
      <Card className="post-detail-card">
        <Button 
          type="text" 
          icon={<LeftOutlined />} 
          onClick={handleBack}
          style={{ marginBottom: 16 }}
        >
          返回首页
        </Button>
        
        <Title className="post-detail-title">{post.title}</Title>
        <Space className="post-meta" size="large" style={{ marginBottom: 24 }}>
          <Text strong>作者: {post.author}</Text>
          <Text type="secondary">{post.date}</Text>
          <Text type="secondary">{post.readTime}</Text>
        </Space>
        
        <Divider />
        
        <div className="post-content">
          <Paragraph>
            {post.content}
          </Paragraph>
          
          <div className="post-tags" style={{ marginTop: 24 }}>
            <Text strong>标签: </Text>
            {post.tags.map((tag, index) => (
              <Tag key={index} color="blue">
                {tag}
              </Tag>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PostDetailPage;